import { render, staticRenderFns } from "./_base-config.vue?vue&type=template&id=142e6dc0"
import script from "./_base-config.vue?vue&type=script&lang=js"
export * from "./_base-config.vue?vue&type=script&lang=js"
import style0 from "./_base-config.vue?vue&type=style&index=0&id=142e6dc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports